import type { Course } from '@/types/course';

export const extractCourseData = (courseData: Course) => ({
  imageSrc: courseData.attributes.cover.data?.attributes.url,
  title: courseData.attributes.title,
  date: courseData.attributes.date,
  description: courseData.attributes.description,
  expertName: courseData.attributes.expert.data?.attributes.name,
  expertImage: courseData.attributes.expert.data?.attributes.picture.data?.attributes.url,
  time_range: courseData.attributes.time_range,
  id: courseData.id,
  expertExternalId: courseData.attributes.expert.data?.id.toString(),
  languages: courseData.attributes.languages?.data
    .map((language) => language.attributes.name)
    .join(', '),
});
